import React from 'react';
import moment from 'moment';
import 'moment/locale/ja';
import DatePicker from 'react-datepicker';
import '../../includes/custom/css/datepicker.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DATE_FORMAT, JA_LOCALE, JA_CALENDAR_FORMAT, EMPTY_STRING } from '../../utils/constants';

let MONDAY_INDEX = 1;

moment.updateLocale(JA_LOCALE, {
    week: {
        dow: MONDAY_INDEX,
    },
    longDateFormat: {
        L: DATE_FORMAT,
    }
});

const labelClass = (props) => {
    if (props.outerIcon) {
        return "datepicker__input-container-outer";
    } else if (props.mobile) {
        return "datepicker__input-container-mobile";
    } else if(props.noIcon){
        return "datepicker__input-noIcon";
    }else{
        return "datepicker__input-container";
    }
}

const JapaneseDatePicker = (props) => {
    return (
        <div className={props.bordered ? "datepicker-container-bordered" : "datepicker-container"}>
            
            <label className={labelClass(props)}>
                <DatePicker
                    id={props.name}
                    onBlur={props.onBlur}
                    onChangeRaw={props.onChangeRaw}
                    name={props.name}
                    selected={props.selected}
                    className={props.className}
                    onChange={props.onChange}
                    dateFormat={props.dateFormat ? props.dateFormat : DATE_FORMAT}
                    locale={JA_LOCALE}
                    dateFormatCalendar={JA_CALENDAR_FORMAT}
                    autoComplete="off"
                    minDate={props.minDate && props.minDate}
                    maxDate={props.maxDate && props.maxDate}
                    disabled={props.disabled}
                    readOnly={props.readOnly}
                    shouldCloseOnSelect={true}
                    preventOpenOnFocus={true}
                    popperPlacement="bottom"
                    popperModifiers={{
                        flip: {
                            behavior: ["bottom"]
                        }
                    }}
                />
                {!props.noIcon ?
                    <span className={props.outerIcon ? "calendar-icon" : "calendar-icon-bordered"}><FontAwesomeIcon icon={['far', "calendar-alt"]} color="#000" /></span>
                    : EMPTY_STRING}
            </label>
            
        </div>
    )
}

export default JapaneseDatePicker;
